import React from "react";

/**
 * Backflow preventer gallery — real device / pipe / valve imagery.
 */
const shots = [
  {
    url: "https://images.unsplash.com/photo-1682540963112-facad29c3fa2?auto=format&fit=crop&w=1200&q=80",
    tag: "RPZ ASSEMBLY",
    title: "Reduced Pressure Zone (RPZ)",
    note: "High-hazard applications — restaurants, medical, irrigation",
  },
  {
    url: "https://images.unsplash.com/photo-1562448079-7557fc7f04e9?auto=format&fit=crop&w=1200&q=80",
    tag: "WATER METER",
    title: "Annual Certified Testing",
    note: "Calibrated gauges · City-accepted reports",
  },
  {
    url: "https://images.unsplash.com/photo-1759148414485-5f624fe9d1ea?auto=format&fit=crop&w=1200&q=80",
    tag: "VALVE ARRAY",
    title: "Commercial Assemblies",
    note: "Double-check and RPZ for properties & HOAs",
  },
  {
    url: "https://images.unsplash.com/photo-1639298432567-bb1655e2a801?auto=format&fit=crop&w=1200&q=80",
    tag: "INDUSTRIAL",
    title: "Large-Scale Installations",
    note: "Warehouses, food service, manufacturing",
  },
  {
    url: "https://images.unsplash.com/photo-1690973692388-239878450c7b?auto=format&fit=crop&w=1200&q=80",
    tag: "FIRE LINE",
    title: "Fire Protection Backflow",
    note: "DCDA assemblies for fire suppression systems",
  },
  {
    url: "https://images.unsplash.com/photo-1767274714714-dda4c25c6376?auto=format&fit=crop&w=1200&q=80",
    tag: "REPAIR & REBUILD",
    title: "Repair & Replace",
    note: "OEM parts · Same-day repair on common models",
  },
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      className="py-20 lg:py-28 bg-white"
      data-testid="gallery-section"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <div className="step-num">02.5 — ON THE JOB</div>
            <h2 className="font-display text-4xl sm:text-5xl font-bold mt-3 tracking-tight max-w-2xl">
              Real devices. Real installs.
            </h2>
          </div>
          <p className="md:max-w-sm text-slate-600">
            From RPZ assemblies to fire-line DCDAs — we work on every backflow preventer type used
            across South Texas.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-0 border-l border-t border-slate-200">
          {shots.map((s, i) => (
            <figure
              key={i}
              className="relative overflow-hidden border-r border-b border-slate-200 group"
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={s.url}
                alt={s.title}
                loading="lazy"
                className="w-full h-72 object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <figcaption className="absolute inset-0 bg-gradient-to-t from-slate-900/95 via-slate-900/40 to-transparent flex flex-col justify-end p-5">
                <span className="inline-block px-2 py-1 bg-orange-500 text-white font-display text-[10px] tracking-[0.18em] font-bold self-start">
                  {s.tag}
                </span>
                <div className="font-display font-bold text-white text-lg mt-2">{s.title}</div>
                <div className="text-xs text-slate-200 mt-1">{s.note}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
